import { NotificationModel } from '../domain';
import { NotificationRepository } from './notification.repository';
import { ApiResponse, NotificationType, StatusValue } from '@/shared';

export class MockHttpNotificationRepository extends NotificationRepository {
  constructor() {
    super();
  }

  async getUnseenNotifications(): Promise<NotificationModel[]> {
    return [
      {
        id: 1,
        createdAt: new Date(),
        type: NotificationType.StatusChanged,
        requestId: 1,
        requestReference: '543',
        requestStatus: StatusValue.InQA,
      },
      {
        id: 2,
        createdAt: new Date(),
        type: NotificationType.StatusChanged,
        requestId: 2,
        requestReference: '544',
        requestStatus: StatusValue.InProgress,
      },
    ];
  }

  async dismissAllNotifications(): Promise<ApiResponse<unknown>> {
    return {
      isSuccess: true,
      timestamp: new Date().getMilliseconds().toString(),
      data: null,
    };
  }

  async dismissNotification(
    notificationId: number,
  ): Promise<ApiResponse<unknown>> {
    return {
      isSuccess: true,
      timestamp: new Date().getMilliseconds().toString(),
      data: notificationId,
    };
  }
}
